module.exports = __webpack_public_path__ + "static/media/breakeven.1fb47cbd.png";